import React, { useContext } from "react";
import "./collage-mobile.scss";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { GatsbyImage } from "gatsby-plugin-image";
import GlobalContext from "../../../contexts/globalContext";
import { normalizeTwoWords } from "../../../shared/utils/stringUtilities";

const CollageMobile = (props: CollageMobileInterface) => {
  const { cardsArray } = props;
  //const [isMenuCurrActive, setMenuCurrActive]? = useState(0);
  const setting = {
    dots: false,
    arrows: false,
    infinite: false,
    speed: 500,
    slidesToShow: 1.2,
    slidesToScroll: 0.8,
    initialSlide: 0,

    responsive: [
      {
        breakpoint: 1025,
        settings: {
          slidesToShow: 1.2,
          slidesToScroll: 0.8,
          infinite: false,
          dots: true,
        },
      },
      {
        breakpoint: 960,
        settings: {
          slidesToShow: 1.2,
          slidesToScroll: 0.8,
          infinite: false,
          dots: true,
        },
      },
      {
        breakpoint: 560,
        settings: {
          slidesToShow: 1.2,
          slidesToScroll: 0.8,
          infinite: false,
          dots: true,
        },
      },
      {
        breakpoint: 440,
        settings: {
          slidesToShow: 1.2,
          slidesToScroll: 1,
          infinite: false,
          dots: true,
        },
      },
    ],
  };

  const dataContext = useContext(GlobalContext);

  const setGmt = (contenido) => {
    if (
      dataContext.userInfoContext.data?.userHaveTransaction ||
      dataContext.userInfoContext.data?.userHaveTransaction != undefined
    ) {
      return `gtmRedDeAmorSesionIniciadaContenidosNuestraRed${normalizeTwoWords(
        contenido
      )}`;
    } else {
      return `gtmRedDeAmorContenidosNuestraRed${normalizeTwoWords(contenido)}`;
    }
  };

  return (
    <>
      {cardsArray > 6 ? (
        <div className="show-on-mobile">
          <Slider {...setting}>
            <div className="m-collage-mobile">
              <div className="m-collage-mobile-card">
                <div className="m-collage-mobile-card-internal">
                  <GatsbyImage
                    className="m-collage-mobile-card-imagen"
                    image={cardsArray[0]?.url}
                    alt={cardsArray[0]?.title}
                  />
                  <div className="information">
                    <h3>{cardsArray[0]?.title}</h3>
                  </div>
                  <a
                    href={cardsArray[0]?.redirect}
                    className={`gradient ${setGmt(cardsArray[0]?.title)}`}
                  />
                  {cardsArray[0]?.costless_chip ? (
                    <div className="chip">
                      <p>Sin Cobro</p>
                    </div>
                  ) : null}
                </div>
                <div className="m-collage-mobile-card-internal2">
                  <GatsbyImage
                    className="m-collage-mobile-card-imagen"
                    image={cardsArray[3]?.url}
                    alt={cardsArray[3]?.title}
                  />
                  <div className="information">
                    <h3>{cardsArray[3]?.title}</h3>
                  </div>
                  <a
                    href={cardsArray[3]?.redirect}
                    className={`gradient ${setGmt(cardsArray[3]?.title)}`}
                  />
                  {cardsArray[3]?.costless_chip ? (
                    <div className="chip">
                      <p>Sin Cobro</p>
                    </div>
                  ) : null}
                </div>
              </div>
            </div>
            <div className="m-collage-mobile">
              <div className="m-collage-mobile-card">
                <div className="m-collage-mobile-card-internal3">
                  <GatsbyImage
                    className="m-collage-mobile-card-imagen"
                    image={cardsArray[1]?.url}
                    alt={cardsArray[1]?.title}
                  />
                  <div className="information">
                    <h3>{cardsArray[1]?.title}</h3>
                  </div>
                  <a
                    href={cardsArray[1]?.redirect}
                    className={`gradient ${setGmt(cardsArray[1]?.title)}`}
                  />
                  {cardsArray[1]?.costless_chip ? (
                    <div className="chip">
                      <p>Sin Cobro</p>
                    </div>
                  ) : null}
                </div>
                <div className="m-collage-mobile-card-internal4">
                  <GatsbyImage
                    className="m-collage-mobile-card-imagen"
                    image={cardsArray[4]?.url}
                    alt={cardsArray[4]?.title}
                  />
                  <div className="information">
                    <h3 className="long-title">{cardsArray[4]?.title}</h3>
                  </div>
                  <a
                    href={cardsArray[4]?.redirect}
                    className={`gradient ${setGmt(cardsArray[4]?.title)}`}
                  />
                  {cardsArray[4]?.costless_chip ? (
                    <div className="chip">
                      <p>Sin Cobro</p>
                    </div>
                  ) : null}
                </div>
              </div>
            </div>
            <div className="m-collage-mobile">
              <div className="m-collage-mobile-card">
                <div className="m-collage-mobile-card-internal6">
                  <GatsbyImage
                    className="m-collage-mobile-card-imagen"
                    image={cardsArray[2]?.url}
                    alt={cardsArray[2]?.title}
                  />
                  <div className="information">
                    <h3>{cardsArray[2]?.title}</h3>
                  </div>
                  <a
                    href={cardsArray[2]?.redirect}
                    className={`gradient ${setGmt(cardsArray[2]?.title)}`}
                  />
                  {cardsArray[2]?.costless_chip ? (
                    <div className="chip">
                      <p>Sin Cobro</p>
                    </div>
                  ) : null}
                </div>
                <div className="m-show-card">
                  <div className="m-show-card__container">
                    <p className="m-show-card__container__text">
                      {cardsArray[5]?.title}
                    </p>
                    <a
                      href={cardsArray[5]?.redirect}
                      className={`m-show-card__container__button ${setGmt(
                        cardsArray[5]?.title
                      )}`}
                    >
                      <p>{cardsArray[5]?.tituloBoton}</p>
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <div className="m-collage-mobile">
              <div className="m-collage-mobile-card">
                <div className="m-collage-mobile-card-internal">
                  <GatsbyImage
                    className="m-collage-mobile-card-imagen"
                    image={cardsArray[6]?.url}
                    alt={cardsArray[6]?.title}
                  />
                  <div className="information">
                    <h3>{cardsArray[6]?.title}</h3>
                  </div>
                  <a
                    href={cardsArray[6]?.redirect}
                    className={`gradient ${setGmt(cardsArray[6]?.title)}`}
                  />
                  {cardsArray[6]?.costless_chip ? (
                    <div className="chip">
                      <p>Sin Cobro</p>
                    </div>
                  ) : null}
                </div>
                <div className="m-collage-mobile-card-internal2">
                  <GatsbyImage
                    className="m-collage-mobile-card-imagen"
                    image={cardsArray[9]?.url}
                    alt={cardsArray[9]?.title}
                  />
                  <div className="information">
                    <h3>{cardsArray[9]?.title}</h3>
                  </div>
                  <a
                    href={cardsArray[9]?.redirect}
                    className={`gradient ${setGmt(cardsArray[9]?.title)}`}
                  />
                  {cardsArray[9]?.costless_chip ? (
                    <div className="chip">
                      <p>Sin Cobro</p>
                    </div>
                  ) : null}
                </div>
              </div>
            </div>
            <div className="m-collage-mobile">
              <div className="m-collage-mobile-card">
                <div className="m-collage-mobile-card-internal3">
                  <GatsbyImage
                    className="m-collage-mobile-card-imagen"
                    image={cardsArray[7]?.url}
                    alt={cardsArray[7]?.title}
                  />
                  <div className="information">
                    <h3>{cardsArray[7]?.title}</h3>
                  </div>
                  <a
                    href={cardsArray[7]?.redirect}
                    className={`gradient ${setGmt(cardsArray[7]?.title)}`}
                  />
                  {cardsArray[7]?.costless_chip ? (
                    <div className="chip">
                      <p>Sin Cobro</p>
                    </div>
                  ) : null}
                </div>
                <div className="m-collage-mobile-card-internal4">
                  <GatsbyImage
                    className="m-collage-mobile-card-imagen"
                    image={cardsArray[10]?.url}
                    alt={cardsArray[10]?.title}
                  />
                  <div className="information">
                    <h3 className="long-title">{cardsArray[10]?.title}</h3>
                  </div>
                  <a
                    href={cardsArray[10]?.redirect}
                    className={`gradient ${setGmt(cardsArray[10]?.title)}`}
                  />
                  {cardsArray[10]?.costless_chip ? (
                    <div className="chip">
                      <p>Sin Cobro</p>
                    </div>
                  ) : null}
                </div>
              </div>
            </div>
            <div className="m-collage-mobile">
              <div className="m-collage-mobile-card">
                <div className="m-collage-mobile-card-internal6">
                  <GatsbyImage
                    className="m-collage-mobile-card-imagen"
                    image={cardsArray[8]?.url}
                    alt={cardsArray[8]?.title}
                  />
                  <div className="information">
                    <h3>{cardsArray[8]?.title}</h3>
                  </div>
                  <a
                    href={cardsArray[8]?.redirect}
                    className={`gradient ${setGmt(cardsArray[8]?.title)}`}
                  />
                  {cardsArray[8]?.costless_chip ? (
                    <div className="chip">
                      <p>Sin Cobro</p>
                    </div>
                  ) : null}
                </div>
                <div className="m-collage-mobile-card-internal5">
                  <GatsbyImage
                    className="m-collage-mobile-card-imagen"
                    image={cardsArray[11]?.url}
                    alt={cardsArray[11]?.title}
                  />
                  <div className="information">
                    <h3>{cardsArray[11]?.title}</h3>
                  </div>
                  <a
                    href={cardsArray[11]?.redirect}
                    className={`gradient ${setGmt(cardsArray[11]?.title)}`}
                  />
                  {cardsArray[11]?.costless_chip ? (
                    <div className="chip">
                      <p>Sin Cobro</p>
                    </div>
                  ) : null}
                </div>
              </div>
            </div>
          </Slider>
        </div>
      ) : (
        <div className="show-on-mobile">
          <Slider {...setting}>
            <div className="m-collage-mobile">
              <div className="m-collage-mobile-card">
                <div className="m-collage-mobile-card-internal">
                  <GatsbyImage
                    className="m-collage-mobile-card-imagen"
                    image={cardsArray[0]?.url}
                    alt={cardsArray[0]?.title}
                  />
                  <div className="information">
                    <h3>{cardsArray[0]?.title}</h3>
                  </div>
                  <a
                    href={cardsArray[0]?.redirect}
                    className={`gradient ${setGmt(cardsArray[0]?.title)}`}
                  />
                  {cardsArray[0]?.costless_chip ? (
                    <div className="chip">
                      <p>Sin Cobro</p>
                    </div>
                  ) : null}
                </div>
                <div className="m-collage-mobile-card-internal2">
                  <GatsbyImage
                    className="m-collage-mobile-card-imagen"
                    image={cardsArray[3]?.url}
                    alt={cardsArray[3]?.title}
                  />
                  <div className="information">
                    <h3>{cardsArray[3]?.title}</h3>
                  </div>
                  <a
                    href={cardsArray[3]?.redirect}
                    className={`gradient ${setGmt(cardsArray[3]?.title)}`}
                  />
                  {cardsArray[3]?.costless_chip ? (
                    <div className="chip">
                      <p>Sin Cobro</p>
                    </div>
                  ) : null}
                </div>
              </div>
            </div>
            <div className="m-collage-mobile">
              <div className="m-collage-mobile-card">
                <div className="m-collage-mobile-card-internal3">
                  <GatsbyImage
                    className="m-collage-mobile-card-imagen"
                    image={cardsArray[1]?.url}
                    alt={cardsArray[1]?.title}
                  />
                  <div className="information">
                    <h3>{cardsArray[1]?.title}</h3>
                  </div>
                  <a
                    href={cardsArray[1]?.redirect}
                    className={`gradient ${setGmt(cardsArray[1]?.title)}`}
                  />
                  {cardsArray[1]?.costless_chip ? (
                    <div className="chip">
                      <p>Sin Cobro</p>
                    </div>
                  ) : null}
                </div>
                <div className="m-collage-mobile-card-internal4">
                  <GatsbyImage
                    className="m-collage-mobile-card-imagen"
                    image={cardsArray[4]?.url}
                    alt={cardsArray[4]?.title}
                  />
                  <div className="information">
                    <h3 className="long-title">{cardsArray[4]?.title}</h3>
                  </div>
                  <a
                    href={cardsArray[4]?.redirect}
                    className={`gradient ${setGmt(cardsArray[4]?.title)}`}
                  />
                  {cardsArray[4]?.costless_chip ? (
                    <div className="chip">
                      <p>Sin Cobro</p>
                    </div>
                  ) : null}
                </div>
              </div>
            </div>
            <div className="m-collage-mobile">
              <div className="m-collage-mobile-card">
                <div className="m-collage-mobile-card-internal6">
                  <GatsbyImage
                    className="m-collage-mobile-card-imagen"
                    image={cardsArray[2]?.url}
                    alt={cardsArray[2]?.title}
                  />
                  <div className="information">
                    <h3>{cardsArray[2]?.title}</h3>
                  </div>
                  <a
                    href={cardsArray[2]?.redirect}
                    className={`gradient ${setGmt(cardsArray[2]?.title)}`}
                  />
                  {cardsArray[2]?.costless_chip ? (
                    <div className="chip">
                      <p>Sin Cobro</p>
                    </div>
                  ) : null}
                </div>
                <div className="m-show-card">
                  <div className="m-show-card__container">
                    <p className="m-show-card__container__text">
                      {cardsArray[5]?.title}
                    </p>
                    <a
                      href={cardsArray[5]?.redirect}
                      className={`m-show-card__container__button ${setGmt(
                        cardsArray[5]?.title
                      )}`}
                    >
                      <p>{cardsArray[5]?.tituloBoton}</p>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </Slider>
        </div>
      )}
    </>
  );
};

interface CollageMobileInterface {
  cardsArray: any;
}

export default CollageMobile;
